import './Equipment.css';

function AboutEquipment() {
  const equipmentList = [
    {
      name: 'Oscilloscope',
      model: 'DSO-X-2012A',
      spec: '100MHz, 2채널',
      qty: '1',
      maker: 'Agilent Technologies'
    },
    {
        name: 'LCR Meter',
        model: 'ZM2372',
        spec: '1mHz~100kHz',
        qty: '1',
        maker: 'NF Corporation'
    },
    {
        name: 'DMM',
        model: '34410A',
        spec: '6.5 Digit',
        qty: '1',
        maker: 'Agilent Technologies'
    },
    {
      name: '3D Printer',
      model: '3DP-310F',
      spec: 'FFF, 240×190×200mm',
      qty: '2',
      maker: 'CUBICON'
    },
    {
      name: 'DC Power supply',
      model: 'DRP-12003D',
      spec: '120V 3A 1Ch',
      qty: '1',
      maker: 'DIGITAL ELECTRONICS'
    },
    {
      name: 'DC Power supply',
      model: 'GPS-2303',
      spec: '30V 3A 2Ch',
      qty: '2',
      maker: 'GWINSTEK'
    },
    {
      name: 'DC Power supply',
      model: 'RDP-305',
      spec: '30V 5A 1Ch',
      qty: '3',
      maker: 'SMART'
    }, 
    {
      name: 'Tube numbering',
      model: 'LM-550KP/PC',
      spec: '',
      qty: '1',
      maker: 'MAX'
    }, 
    {
      name: 'Window Control ICT',
      model: 'TAMA-ICT-1000',
      spec: '',
      qty: '1',
      maker: 'TAMA'
    }, 
    {
      name: 'Terminal Press Machine',
      model: 'M/C-502',
      spec: '',
      qty: '1',
      maker: 'HARNESS119'
    }, 
    {
      name: 'Multimedia Display Tester',
      model: '329802-E',
      spec: '',
      qty: '1',
      maker: 'YOKOGAWA'
    }, 
    {
        name: 'StereoMicroscope',
        model: 'SMZ645',
        spec: '0.8x - 5x, 10x W.F.',
        qty: '1',
        maker: 'Nikon'
    },
    {
      name: 'Sound Level Meter',
      model: 'KR-1352R',
      spec: '30~130dB',
      qty: '1',
      maker: 'KR Tech'
    }
];

  return (
    <div className="overview-container">
      <div className="heat-section-title">장비보유현황</div>
      <div className="equipment-table">
        <table>
          <thead>
            <tr>
              <th>장비/기기명</th>
              <th>모델명</th>
              <th>규격</th>
              <th>수량</th>
              <th>제조사</th>
            </tr>
          </thead>
          <tbody>
            {equipmentList.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.model}</td>
                <td>{item.spec}</td>
                <td>{item.qty}</td>
                <td>{item.maker}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AboutEquipment;
